export default function BookingStrip({ resNo, supplier, vehicle
 }) {
  const details = [
    { label: 'Confirmation', val: resNo },
    { label: 'Supplier', val: supplier },
    { label: 'vehicle', val: vehicle}
  ];
  return (
    <div className="mb-6 flex rounded-md border border-borderMuted">
      {details.map((d, i) => (
        <div key={i} className={`flex-1 p-3 text-center ${i !== 2 ? 'border-r border-borderMuted' : ''}`}>
          <p className="text-[9px] font-bold uppercase tracking-widest text-gray-400">{d.label}</p>
          <p className="text-xs font-bold">{d.val}</p>
        </div>
      ))}
    </div>
  );
}